import advance from './advance'
import advanceSign from './advance/sign'

const enroll = {
  path: 'enroll',
  component: resolve => require(['../../pages/enroll'], resolve),
  redirect: 'enroll/advance',
  children: [
    advance,
    advanceSign
  ]
}

export default enroll
